import React from "react";
import { Typography } from "@mui/material";
import colors from "../../utils/colors";

export const expressionHelperTextSx = { fontSize: 12, color: colors.neutral[600], mx: 0, mt: 0.5 };
export const expressionErrorTextSx = { fontSize: 12, color: colors.red?.[500] || "#d32f2f", mx: 0, mt: 0.5 };

/** BM-style single line: show error when visible, otherwise hint. */
export function ExpressionFieldMessage({ error, hint }) {
  const message = error || hint;
  if (!message) return null;
  return <Typography sx={error ? expressionErrorTextSx : expressionHelperTextSx}>{message}</Typography>;
}
